import React, { useEffect, useState } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { withSocket } from "../../socket/context";
import { compose } from "redux";
import { removeUser } from "../shared/utils";
import righticon from "../../assets/images/sbs/right.png";
import cx from "classnames";

import closeIcon from "../../assets/images/sbs/cross.png";

const SmallBitesUsers = (props) => {
  const [allPlayersDoneState, setallPlayersDoneState] = useState(true);
  const users = _.get(props, "gameReducer.roomObj.users");
  const players = _.get(props, "gameReducer.roomObj.game_state.player");
  const delPlayer = (data) => {
    const roomObj = props.gameReducer.roomObj;
    removeUser(roomObj, data);
    props.setSelectedAsker(null);
  };

  const playAudio = (url) => {
    var audio = document.createElement("audio");
    audio.src = url;
    audio.style.display = "none"; //added to fix ios issue
    audio.autoplay = true; //avoid the user has not interacted with your page issue
    audio.onended = function () {
      audio.remove(); //remove after playing to clean the Dom
    };
    document.body.appendChild(audio);
  };

  const [userData, setUserData] = useState([]);
  const [usersLength, setusersLength] = useState();

  useEffect(() => {
    if (users && users.length > 0 && players && players.length > 0) {
      const userss = users?.map((item) => {
        for (let i of players) {
          if (i.player_id === item.player_id) {
            if (i.hasOwnProperty("answer")) {
              return { ...item, highlight: true };
            }
          }
        }
        return { ...item, highlight: false };
      });

      setUserData(userss);
    } else {
      const userss = users?.map((elem) => {
        return { ...elem, highlight: false };
      });
      setUserData(userss);
    }
  }, [players, users]);

  useEffect(() => {
    if (users.length > usersLength) {
      playAudio(users[users.length - 1]?.audio_effect);
    }

    setusersLength(users.length);
  }, [users.length]);

  useEffect(() => {
    if (players && players.length > 0) {
      let count = 0;
      for (let player of players) {
        if (!!player.answer_time) {
          count++;
        }
      }
      if (!!props.gameReducer?.roomObj.game_state.asker) {
        count++;
      }
      console.log(
        props.selectedAsker,
        players,
        count,
        "playersplayersplayersplayers"
      );
      if (count === players.length) {
        setTimeout(() => {
          props.onTimesUp();
        }, 1000);
      }
    }
  }, [players]);
  


  return (
    <>
      <div className="players-box">
        {userData &&
          userData.length > 0 &&
          userData?.map((user) => (
            <div
              className={cx("single-player", {
                active: user?.player_id === props.selectedAsker?.player_id,
                highlight: !!user?.highlight,
              })}
            >
              <p className="name" onClick={() => props.setSelectedAsker(user)}>
                {user.display_name}
              </p>
              <div className="check-close">
                {/* {!!user?.highlight && <img src={righticon} alt="" />} */}
                <img src={closeIcon} alt="" onClick={() => delPlayer(user)} />
              </div>
            </div>
          ))}
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
});

export default compose(withSocket, connect(mapStateToProps, null))(SmallBitesUsers);
